
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const HoodCleaningPage = () => {
  const faqs = [
    {
      question: 'Davlumbaz temizliği ne sıklıkla yapılmalıdır?',
      answer: 'Restoran ve endüstriyel mutfaklarda davlumbaz temizliği 3-6 ayda bir yapılmalıdır. Yoğun kullanılan mutfaklarda bu süre daha kısa olabilir. Düzenli temizlik yangın riskini önemli ölçüde azaltır.',
    },
    {
      question: 'Davlumbaz temizliği fiyatları nedir?',
      answer: 'Davlumbaz temizliği fiyatları, mutfağın büyüklüğü, davlumbaz sistemi, kanal uzunluğu ve kirlilik derecesine göre değişir. Ücretsiz keşif sonrası net fiyat teklifi sunuyoruz.',
    },
    {
      question: 'Davlumbaz kanal temizliği neden önemlidir?',
      answer: 'Davlumbaz kanallarında biriken yağ ve gres yangın için en büyük risk faktörüdür. Düzenli temizlik yangın riskini azaltır, havalandırma verimliliğini artırır ve hijyen standartlarını sağlar.',
    },
    {
      question: 'Temizlik sırasında mutfak kapalı mı kalır?',
      answer: 'Temizlik işlemi genellikle mutfağın kapalı olduğu saatlerde yapılır. Acil durumlar için hızlı temizlik seçeneğimiz mevcuttur.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              Davlumbaz ve Kanal Temizliği
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Restoran ve endüstriyel mutfaklar için profesyonel davlumbaz temizliği hizmeti
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="font-display font-bold text-3xl text-dark-900 mb-6">
              Davlumbaz Temizliği Hizmeti
            </h2>
            <p className="text-dark-600 leading-relaxed mb-6">
              <strong>Davlumbaz temizliği</strong>, restoran, kafe, otel ve endüstriyel mutfaklarda yangın güvenliği için kritik öneme sahiptir. İpek Yangın Söndürme olarak, profesyonel ekipman ve deneyimli kadromuzla <strong>davlumbaz ve kanal temizliği</strong> hizmeti sunuyoruz.
            </p>
            <p className="text-dark-600 leading-relaxed mb-6">
              Mutfak davlumbazlarında ve havalandırma kanallarında biriken yağ, gres ve yanıcı maddeler yangın için en büyük risk faktörüdür. Düzenli <strong>davlumbaz kanal temizliği</strong> ile bu riski minimize ediyoruz.
            </p>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4 mt-12">
              Davlumbaz Temizliği Süreci
            </h3>
            <div className="space-y-6 mb-12">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  1
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Ön Keşif ve Planlama</h4>
                  <p className="text-dark-600">Mutfak ve davlumbaz sistemi incelenir, temizlik planı oluşturulur.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  2
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Koruma Önlemleri</h4>
                  <p className="text-dark-600">Mutfak ekipmanları ve zemin koruma altına alınır.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  3
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Davlumbaz Filtre Temizliği</h4>
                  <p className="text-dark-600">Yağ filtreleri sökülür, özel kimyasallarla derin temizlik yapılır.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  4
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Kanal Temizliği</h4>
                  <p className="text-dark-600">Havalandırma kanalları özel ekipmanlarla detaylı şekilde temizlenir.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  5
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Fan ve Motor Temizliği</h4>
                  <p className="text-dark-600">Aspiratör fanı ve motor bölümü temizlenir, bakımı yapılır.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  6
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Kontrol ve Raporlama</h4>
                  <p className="text-dark-600">Temizlik sonrası sistem kontrolü yapılır, detaylı rapor hazırlanır.</p>
                </div>
              </div>
            </div>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Davlumbaz Temizliği Neden Önemlidir?
            </h3>
            <ul className="list-disc list-inside space-y-3 text-dark-600 mb-8">
              <li><strong>Yangın Riski:</strong> Biriken yağ ve gres tutuşarak büyük yangınlara neden olabilir</li>
              <li><strong>Hijyen Standartları:</strong> Gıda güvenliği mevzuatı düzenli temizlik gerektirir</li>
              <li><strong>Havalandırma Verimliliği:</strong> Kirli kanallar havalandırma performansını düşürür</li>
              <li><strong>Enerji Tasarrufu:</strong> Temiz sistem daha az enerji tüketir</li>
              <li><strong>Yasal Zorunluluk:</strong> İş güvenliği ve gıda mevzuatı uyumu</li>
              <li><strong>Sigorta Gerekliliği:</strong> Sigorta şirketleri düzenli temizlik belgesi talep eder</li>
            </ul>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Hangi Alanlarda Hizmet Veriyoruz?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Restoranlar ve Lokantalar</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Kafeler ve Pastaneler</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Oteller ve Konaklama Tesisleri</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Endüstriyel Mutfaklar</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Hastane ve Okul Yemekhaneleri</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Fabrika Kantinleri</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Fast Food Zincirleri</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Catering Firmaları</p>
              </div>
            </div>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Temizlik Sonrası Faydalar
            </h3>
            <ul className="list-disc list-inside space-y-2 text-dark-600 mb-8">
              <li>Yangın riskinde %90'a varan azalma</li>
              <li>Havalandırma verimliliğinde artış</li>
              <li>Enerji tüketiminde tasarruf</li>
              <li>Mutfak hijyeninde iyileşme</li>
              <li>Koku ve duman problemlerinin çözümü</li>
              <li>Yasal uyumluluk ve belgelendirme</li>
              <li>Ekipman ömrünün uzaması</li>
            </ul>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Servis Bölgelerimiz
            </h3>
            <p className="text-dark-600 leading-relaxed mb-8">
              [Şehir] ve tüm ilçelerinde <strong>davlumbaz temizliği</strong> hizmeti vermekteyiz. Düzenli bakım sözleşmeleri ile özel fiyat avantajlarından yararlanabilirsiniz.
            </p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-dark-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-dark-900 mb-12 text-center">
            Hizmetimizin Avantajları
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Profesyonel Ekipman</h3>
              <p className="text-dark-600 text-sm">Endüstriyel temizlik makineleri ve kimyasallar</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Esnek Çalışma</h3>
              <p className="text-dark-600 text-sm">Mutfağın kapalı olduğu saatlerde hizmet</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Güvenli Çalışma</h3>
              <p className="text-dark-600 text-sm">Tüm güvenlik standartlarına uygun hizmet</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Belgelendirme</h3>
              <p className="text-dark-600 text-sm">Detaylı temizlik raporu ve sertifika</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-dark-900 mb-12 text-center">
            Sık Sorulan Sorular
          </h2>
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-dark-50 rounded-lg p-6 border-l-4 border-primary-600">
                <h3 className="font-display font-semibold text-xl text-dark-900 mb-3">
                  {faq.question}
                </h3>
                <p className="text-dark-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-6">
            Davlumbaz Temizliği İçin Hemen Arayın
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Ücretsiz keşif ve profesyonel hizmet için bizimle iletişime geçin
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="tel:+905XXXXXXXXX" 
              className="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-50 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-phone-line"></i>
              <span>Hemen Ara</span>
            </a>
            <a 
              href="https://wa.me/905XXXXXXXXX" 
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="bg-green-500 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-600 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-whatsapp-line"></i>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HoodCleaningPage;
